module.exports = __webpack_public_path__ + "img/pic_default_woman.8dc4fad3.png";